import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "padding-30"
};
const _hoisted_2 = {
  key: 0,
  class: "flex-row",
  style: {
    "justify-content": "flex-end"
  }
};
const _hoisted_3 = {
  class: "flex-column-center"
};
const _hoisted_4 = {
  class: "font-28",
  style: {
    "text-align": "center"
  }
};
const _hoisted_5 = {
  class: "font-28 top-10",
  style: {
    "text-align": "center"
  }
};
import { onMounted, ref, watch } from 'vue';
import bus from '@/utils/bus';
export default {
  __name: 'App',
  setup(__props) {
    const show_app = ref(false);
    const tipState = ref({
      showTip: false,
      title: '',
      msg: '',
      pop_closeable: true
    });
    const beforeClose = action => {
      if (action === 'confirm' && tipState.value.pop_closeable == 0) {
        return false;
      } else {
        return true;
      }
    };
    const onConfirm = () => {
      window.open('https://applink.feishu.cn/client/helpdesk/open?id=7203249560976670723&extra=%7B%22channel%22%3A1%2C%22created_at%22%3A1689236901%7D');
    };
    const closeTip = () => {
      tipState.value.showTip = false;
    };
    const handleLoginInfo = res => {
      let {
        msg_title,
        msg_desc,
        show_pop,
        pop_closeable
      } = res;
      tipState.value.showTip = show_pop == 1;
      tipState.value.title = msg_title;
      tipState.value.msg = msg_desc;
      tipState.value.pop_closeable = pop_closeable;
    };
    onMounted(() => {
      // 判断当前环境是否是飞书
      if (!window.h5sdk) {
        alert('请在飞书环境中打开本网页');
        show_app.value = false;
      } else {
        show_app.value = true;
        if (window.location.href.indexOf('pc') == -1) {
          bus.on('onLogin', handleLoginInfo);
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_dialog = _resolveComponent("van-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [show_app.value ? (_openBlock(), _createBlock(_component_router_view, {
        key: 0
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_van_dialog, {
        show: tipState.value.showTip,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => tipState.value.showTip = $event),
        "confirm-button-text": "联系客服",
        onConfirm: onConfirm,
        "before-close": beforeClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [tipState.value.pop_closeable == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_icon, {
          name: "cross",
          onClick: closeTip
        })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_icon, {
          name: "warning",
          color: "#fe9900",
          size: "60"
        })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_4, _toDisplayString(tipState.value.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(tipState.value.msg), 1)])])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};